export default __webpack_public_path__ + "static/media/vas-image-4.19bc449a.svg";